import { addDynamicTitle } from "./utils/addDynamicTitle";


let forms = [];

function initializeTracking() {
    // Assuming you have access to utmParams here, otherwise, you'll need to obtain it.
    const queryParams = getQueryParams();
    const marketingParams = [
        "utm_source",
        "utm_medium",
        "utm_campaign",
        "utm_term",
        "utm_content",
        "utm_device",
        "utm_placement",
        "utm_gclid",
        "fbclid",
        // Add more params here
    ];

    let utmParams = {};

    const hostName = window.location.hostname;
    utmParams["hostname"] = hostName;

    const pathName = window.location.pathname;
    const splitedPathName = pathName.split("/");
    const conversionPage = splitedPathName[splitedPathName.length - 1];
    utmParams["conversion_page"] = conversionPage;

    const landingPage = splitedPathName[splitedPathName.length - 1];
    utmParams["landing_page"] = landingPage;

    const referrer = document.referrer;
    utmParams["referrer"] = referrer;

    const channel = hostName === "clinic.neuroimprove.pt" ? "lp_form" : "site_form";
    utmParams["channel"] = channel;

    marketingParams.forEach((param) => {
        if (queryParams[param]) {
            // Add param to the params object to be saved
            utmParams[param] = queryParams[param];
        }
    });


    if (!localStorage.getItem("utm_params")) {
        localStorage.setItem("utm_params", JSON.stringify(utmParams));
    }

    const existingUtmParamsString = localStorage.getItem("utm_params");


    if (existingUtmParamsString) {
        const existingUtmParams = JSON.parse(existingUtmParamsString);
        const mergedUtmParams = {
            ...existingUtmParams,
            ...utmParams,
            referrer: existingUtmParams.referrer || utmParams.referrer,
            landing_page: existingUtmParams.landing_page || utmParams.landing_page
        };
        localStorage.setItem("utm_params", JSON.stringify(mergedUtmParams));
    } else {
        localStorage.setItem("utm_params", JSON.stringify(utmParams));
    }

    addDynamicTitle();

    // Find all forms with formType="captureLead"
    forms = document.querySelectorAll('form[formType="captureLead"]');

    const utmParamsString = localStorage.getItem("utm_params");
    if (utmParamsString) {
        // Loop through each form and add a hidden input field
        forms.forEach((form) => {
            const parsedUtmParams = JSON.parse(utmParamsString);
            Object.entries(parsedUtmParams).forEach(([key, value]) => {
                if (value) {
                    const hiddenInput = document.createElement("input");
                    hiddenInput.type = "hidden";
                    hiddenInput.name = key;
                    hiddenInput.value = value;

                    form.appendChild(hiddenInput);
                }
            });
        });
    }
}

// Initialize tracking when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeTracking);
} else {
    // DOM is already ready
    initializeTracking();
}

window.addEventListener("load", () => {
    // Get the Google Analytics Client ID and add it to the form
    gtag("get", "G-NMP27LP3KJ", "client_id", function (clientId) {
        const hiddenInput = document.createElement("input");
        hiddenInput.type = "hidden";
        hiddenInput.name = "analytics_user_id";
        hiddenInput.value = clientId;

        if (forms[0]) {
            forms[0].appendChild(hiddenInput);
        }
    });
});

function getQueryParams() {
    const queryString = window.location.search.substring(1);
    const pairs = queryString.split("&");
    const params = {};

    pairs.forEach((pair) => {
        const [key, value] = pair.split("=");
        params[decodeURIComponent(key)] = decodeURIComponent(value);
    });

    return params;
    
}
